module.exports = __webpack_public_path__ + "img/atm-no.ba6d853f.svg";